import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { oneLineTrim } from 'common-tags';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';
import { message } from 'antd';

function* fetchDowntimeOperations({ downtimeOperationsParams }) {
  try {
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'downtime/getsearched',
      params: downtimeOperationsParams,
    });
    const downtimeOperationsData = data;
    yield put(Actions.setDowntimeOperations({ downtimeOperationsData }));
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addUpdateDowntimeOperation({ actionName, downtimeOperationObj, downtimeOperationsParams, callback }) {
  try {
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: true }));
    const { data } = yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: `downtime`,
      data: downtimeOperationObj,
    });
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: false }));
    const downtimeData = data ? data.toJS() : [];
    if (downtimeData.id === 0 && !downtimeOperationObj.allEquipments) {
      notification('info', CONSTANT_VARIABLES.UPDATE_PLANNED_UNPLANNED_DOWNTIME_REASON, '');
    } else {
      yield put(Actions.fetchDowntimeOperations({ downtimeOperationsParams }));
      notification(
        'success',
        actionName === CONSTANT_VARIABLES.ADD
          ? CONSTANT_VARIABLES.DOWNTIME_CREATED
          : CONSTANT_VARIABLES.DOWNTIME_UPDATED,
        ''
      );
      if (callback) callback();
    }
  } catch (err) {
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* setBulkDowntime({ bulkDowntimeList, downtimeOperationsParams, callback }) {
  try {
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: true }));
    const { data } = yield call(api.put, {
      route: `downtime/updateBulkDowntime`,
      data: bulkDowntimeList,
    });
    yield put(Actions.fetchDowntimeOperations({ downtimeOperationsParams }));
    const messagesData = data ? data.toJS() : [];
    if (messagesData.messages !== null && messagesData.messages.length > 0) {
      for (message of messagesData.messages) {
        notification('info', message, '');
      }
    } else {
      if (callback) callback();
      notification('success', CONSTANT_VARIABLES.DOWNTIME_UPDATED, '');
    }
  } catch (err) {
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteDowntimeOperation({ downtimeId, downtimeOperationsParams }) {
  try {
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: true }));
    yield call(api.delete, {
      route: `downtime/${downtimeId}`,
    });
    yield put(Actions.fetchDowntimeOperations({ downtimeOperationsParams }));
    notification('success', CONSTANT_VARIABLES.DOWNTIME_DELETED, '');
  } catch (err) {
    yield put(Actions.setDowntimeOperationsLoaderStatus({ downtimeOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* checkTimeRangeDowntimeOperation({ downtimeRangeParams }) {
  try {
    const { data } = yield call(api.get, {
      route: oneLineTrim`downtime/DowntimeRangeCheck
             /${downtimeRangeParams.equipmentId}
             /${downtimeRangeParams.fromDate}
             /${downtimeRangeParams.toDate}`,
    });
    const downtimeRangeStatus = data;
    yield put(Actions.setTimeRangeDowntimeOperation({ downtimeRangeStatus }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_DOWNTIME_OPERATIONS, fetchDowntimeOperations),
    takeLatest(ActionTypes.ADD_UPDATE_DOWNTIME_OPERATION, addUpdateDowntimeOperation),
    takeLatest(ActionTypes.DELETE_DOWNTIME_OPERATION, deleteDowntimeOperation),
    takeLatest(ActionTypes.CHECK_TIME_RANGE_DOWNTIME_OPERATION, checkTimeRangeDowntimeOperation),
    takeLatest(ActionTypes.SET_BULK_DOWNTIME_REASON, setBulkDowntime),
  ]);
}
